export const autoFightHourList = [
  { class: 'unique', value: 96, vipLevel: 3 },
  { class: 'epic', value: 48, vipLevel: 2 },
  { class: 'race', value: 24, vipLevel: 1 },
  { class: 'normal', value: 8, vipLevel: 0 },
]
